export default __webpack_public_path__ + "static/media/1492509283_app_store_ios7_ios_7.e7a5bbe1.png";